define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/xml"
], function(declare,Controller,xml) {

	return declare(Controller, {
		toWriterRequest: function() {
			// summary: add paste-data param to server op
			var call = this.inherited(arguments);
			call.addParameter("Data", xml.ATTR_STRING, this.getFormData().getFieldInitialValue("Data"));
			call.addParameter("SizeChartUrl", xml.ATTR_REF, this.widget.viewParent.getSizeChart().$URL);
			return call;
		}
	});
});